fragment InvoiceTemplateFragment on Invoice {
    id
    creatorUser {
        id
        name
    }
    createdTime
    modifiedTime
    headerLeftColumn
    headerRightColumn
    body
    footer
    isSkuShown
    isTermShown
    isDiscountShown
    logo
    purchaseOrderNumber
    jobNumber
    customerNumber
    referenceNumber
    paymentAndTerms
    isSignatureShown
}
